import React from 'react';
import { industries } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';
import { Helmet } from "react-helmet";
const Industries = () => {
  return (
    <>
    
      {/* Engineering Section */}
      <section className="industry-split" id="engineering">
        <div className="industry-split-container">
          <div className="industry-split-image">
            <img 
              src={industries[0].image} 
              alt={industries[0].title}
              className="split-img"
            />
            <div className="split-overlay"></div>
          </div>
          
          <div className="industry-split-content">
            <span className="section-label-modern">FOR INNOVATORS</span>
            <h2 className="industry-split-title">{industries[0].title}</h2>
            <p className="industry-split-description">{industries[0].description}</p>
            
            <ul className="industry-split-features">
              {industries[0].features.map((feature, idx) => (
                <li key={idx} className="split-feature-item">
                  <CheckCircle2 className="feature-check" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            
            <p className="industry-split-tagline">{industries[0].tagline}</p>
          </div>
        </div>
      </section>

      {/* Industrial Section */}
      <section className="industry-split reverse" id="industrial">
        <div className="industry-split-container">
          <div className="industry-split-image">
            <img 
              src={industries[1].image} 
              alt={industries[1].title}
              className="split-img"
            />
            <div className="split-overlay"></div>
          </div>
          
          <div className="industry-split-content">
            <span className="section-label-modern">FOR MANUFACTURERS</span>
            <h2 className="industry-split-title">{industries[1].title}</h2>
            <p className="industry-split-description">{industries[1].description}</p>
            
            <ul className="industry-split-features">
              {industries[1].features.map((feature, idx) => (
                <li key={idx} className="split-feature-item">
                  <CheckCircle2 className="feature-check" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            
            <p className="industry-split-tagline">{industries[1].tagline}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Industries;
